import React, { useEffect, useState } from 'react';

import { Close } from '../../icons';
import { StyledCloseButton, StyledModalBox } from './ModalBox.styles';
import { IModalBoxProps } from './ModalBox.types';

const ModalBox = ({
  ariaLabel = 'Close',
  children,
  open,
  handleCloseModal,
}: IModalBoxProps): JSX.Element => {
  const [isOpen, setIsOpen] = useState<boolean>(open);

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  return (
    <StyledModalBox handleCloseModal={handleCloseModal} open={isOpen}>
      <StyledCloseButton aria-label={ariaLabel} onClick={handleCloseModal}>
        <Close />
      </StyledCloseButton>
      {children}
    </StyledModalBox>
  );
};

export default ModalBox;
